import React, {
  createContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";
import API_BASE_URL from "../config/api";

export const CalendarContext = createContext("");

export const CalendarContextProvider = ({ children }) => {
  // Calendar popup states
  const [openCalendar, setOpenCalendar] = useState(false);
  const [openUpdateCalendar, setOpenUpdateCalendar] = useState(false);
  const [newEvent, setNewEvent] = useState("");
  const [ListOfEvent, setListOfEvent] = useState([]);
  const [title, setEventTitle] = useState("");
  const [start, setStartEvent] = useState("");
  const [end, setEndEvent] = useState("");
  const [description, setEventDesc] = useState("");
  const [location, setEventLocation] = useState("");
  const [eventId, setEventId] = useState("");

  // Create Event
  const HandleNewEvent = useCallback(() => {
    const eventData = {
      title,
      start: new Date(start),
      end: new Date(end),
      description,
      location,
    };

    axios
      .post(`${API_BASE_URL}/event`, eventData, {
        headers: {
          myToken: localStorage.getItem("myToken"),
        },
      })
      .then((res) => {
        if (res.data.error) {
          alert("Veuillez d'abord vous authentifier");
        } else {
          setNewEvent(res.data);
          setListOfEvent((prevEvents) => [
            ...prevEvents,
            {
              title,
              start: new Date(start),
              end: new Date(end),
              description,
              location,
            },
          ]);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la création de l'événement :", error);
      });
  }, [title, start, end, description, location]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/event`)
      .then((res) => setListOfEvent(res.data))
      .catch((error) => {
        console.error("Erreur lors de la récupération des événements :", error);
      });
  }, []);

  // Delete Event
  const deleteEvent = useCallback((eventId) => {
    axios
      .delete(`${API_BASE_URL}/event/${eventId}`, {
        headers: {
          myToken: localStorage.getItem("myToken"),
        },
      })
      .then((res) => {
        if (res.data.error) {
          alert("Veuillez d'abord vous authentifier");
        } else {
          alert("Événement supprimé avec succès");
          setListOfEvent((prevEvents) =>
            prevEvents.filter((event) => event._id !== eventId)
          );
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la suppression de l'événement :", error);
      });
  }, []);

  const contextValue = useMemo(
    () => ({
      deleteEvent,
      HandleNewEvent,
      openCalendar,
      setOpenCalendar,
      setEventTitle,
      setEventLocation,
      setStartEvent,
      setEndEvent,
      setEventDesc,
      newEvent,
      ListOfEvent,
      eventId,
      setEventId,
      setListOfEvent,
      openUpdateCalendar,
      setOpenUpdateCalendar,
    }),
    [
      deleteEvent,
      HandleNewEvent,
      openCalendar,
      setOpenCalendar,
      setEventTitle,
      setEventLocation,
      setStartEvent,
      setEndEvent,
      setEventDesc,
      newEvent,
      ListOfEvent,
      eventId,
      setEventId,
      setListOfEvent,
      openUpdateCalendar,
      setOpenUpdateCalendar,
    ]
  );

  return (
    <CalendarContext.Provider value={contextValue}>
      {children}
    </CalendarContext.Provider>
  );
};
